import { render } from "./AccessRequested.vue?vue&type=template&id=7237d8d0"
import script from "./AccessRequested.vue?vue&type=script&lang=js"
export * from "./AccessRequested.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__